import { IconButton, Snackbar, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import React, { useState } from "react";

const useStyles = makeStyles(
  {
    disabledTextfield: {
      "& .MuiInputBase-root": {
        "& .MuiButton-root": {
          "& span": {
            border: "none"
          }
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none"
        },
        border: "none",
        fontSize: "25px !important"
      },
      border: "none",
      fontWeight: "bold"
    }
  },
  { name: "ClipboardNew" }
);

export interface ClipboardNewProps {
  label: string;
  value: string;
  onGenerate: () => void;
  disabled?: boolean;
}

const showDelay = 3000;

const ClipboardNew: React.FC<ClipboardNewProps> = ({
  label,
  value,
  onGenerate,
  disabled
}) => {
  const classes = useStyles("");

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleClick = () => {
    if (value) {
      navigator.clipboard.writeText(value);
      setOpenSnackbar(true);
    } else {
      onGenerate();
    }
  };

  return (
    <div>
      <TextField
        label={label}
        value={value || ""}
        InputProps={{
          endAdornment: (
            <IconButton
              color="primary"
              onClick={handleClick}
              disabled={disabled}
            >
              <FileCopyOutlinedIcon></FileCopyOutlinedIcon>
            </IconButton>
          )
        }}
        className={classes.disabledTextfield}
      />
      <Snackbar
        open={openSnackbar}
        autoHideDuration={showDelay}
        onClose={() => setOpenSnackbar(false)}
        message="Copied to clipboard!"
        key="topcenter"
      />
    </div>
  );
};

export default ClipboardNew;
